import React, { ReactNode } from 'react'

import { DDSTypography } from 'den-design-system'
import pallete from '../../../../global/newPallete'

interface ProgressCardProps {
  heading: string
  value: number
  totalValue: number | string
  icon: ReactNode
  monthly: any
  oneTime: any
}

const BillingCard: React.FC<ProgressCardProps> = ({
  heading,
  value,
  totalValue,
  icon,
  monthly,
  oneTime
}) => {
  const isUnlimited = totalValue === '-1' || totalValue === 'unlimited'

  const getPercentageFromValues = () => {
    if (isUnlimited) return 100
    if (totalValue === 0) return 0

    const percentage = (value / Number(totalValue)) * 100
    return parseFloat(percentage.toFixed(2))
  }

  const percentage = getPercentageFromValues()

  const getProgressBarColor = (percentage: number) => {
    if (isUnlimited) return pallete.colors.warningGreen
    if (percentage <= 70) return pallete.colors.warningGreen
    if (percentage > 70 && percentage <= 90) return pallete.colors.warningOrange
    if (percentage > 90) return pallete.colors.warningRed2
    return pallete.colors.stroke1
  }

  return (
    <div
      className='flex flex-col gap-[16px] border bg-white py-[14px] px-[14px] w-full max-w-sm'
      style={{
        borderColor: pallete.colors.stroke5,
        borderWidth: '1px',
        borderRadius: '12px'
      }}
    >
      {/* Heading Row with right-side text */}
      <div className='flex items-center justify-between mt-[8px]'>
        <div className='flex items-center gap-[8px]'>
          <div
            className='flex justify-center items-center'
            style={{
              width: '32px',
              height: '32px',
              padding: '8px',
              borderRadius: '100px',
              background: '#EDF4FF'
            }}
          >
            {icon}
          </div>
          <DDSTypography.Title
            type='h5'
            variant='bold'
            color={pallete.colors.textDark3}
          >
            {heading}
          </DDSTypography.Title>
        </div>

        {(monthly || oneTime) && (
          <span style={{ color: pallete.colors.textDark6 }}>
            <DDSTypography.Paragraph
              size='para'
              variant='medium'
              color={pallete.colors.textDark6}
            >
              {monthly ? 'Resets Monthly' : 'One Time Allocation'}
            </DDSTypography.Paragraph>
          </span>
        )}
      </div>

      <div>
        {/* Progress Bar */}
        <div className='w-full bg-gray-200 h-2 rounded-full'>
          <div
            className='h-2 rounded-full'
            style={{
              width: `${percentage}%`,
              backgroundColor: `${getProgressBarColor(percentage)}`
            }}
          />
        </div>
        {/* Progress Text */}
        <div className='flex justify-between items-center mt-[12px]'>
          <DDSTypography.Title
            type='h5'
            variant='bold'
            color={pallete.colors.textDark3}
          >
            {value}
            <span
              style={{
                fontSize: '14px',
                fontWeight: 400,
                color: pallete.colors.textDark6
              }}
            >
              {' '}
              / {isUnlimited ? 'Unlimited' : totalValue}
            </span>
          </DDSTypography.Title>
          <div>
            <DDSTypography.Paragraph
              variant='regular'
              size='para'
              color={getProgressBarColor(percentage)}
            >
              {isUnlimited ? 'Unlimited' : `${percentage}%`}
            </DDSTypography.Paragraph>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillingCard
